<template>
  <div id="StdAttribute" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row :gutter="30" style="height: 100%">
        <el-col :span="12" style="height: 100%">
          <div>
            <el-input
              size="small"
              :placeholder="`${$t('pleaseEnterKeyWords')}`"
              v-model.trim="groupParams.keyword"
              clearable
              class="w-200px"
            />
            <el-button class="ml-10px" type="primary" size="small" @click="searchGroupData()">{{
              $t('search')
            }}</el-button>
            <el-button
              type="primary"
              size="small"
              @click="addGroup()"
              :disabled="!$hasAccess('create')"
              >{{ $t('create') }}</el-button
            >
          </div>
          <el-table
            border
            stripe
            :data="groupTableData"
            v-loading="groupTableLoading"
            @row-click="clickGroupTableRow"
            :highlight-current-row="true"
            height="calc(100% - 102px)"
            style="width: 100%; overflow-y: auto"
            ref="groupTable"
            class="mt-20px"
          >
            <el-table-column :label="`${$t('seqNo')}`" prop="seqNo" width="55"></el-table-column>
            <el-table-column :label="`${$t('identifyGroupCode')}`" prop="code"></el-table-column>
            <el-table-column :label="`${$t('identifyGroupName')}`" prop="name"></el-table-column>
            <el-table-column :label="`${$t('operate')}`" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="viewIdentifyGroup(scope.row.id)"
                  :disabled="!$hasAccess('read')"
                  >{{ $t('view') }}</el-button
                >
                <el-button
                  size="mini"
                  @click="editGroup(scope.row.id)"
                  :disabled="!$hasAccess('update')"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  size="mini"
                  @click="deleteGroup(scope.row.id)"
                  :disabled="!$hasAccess('delete')"
                  >{{ $t('delete') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20px"
            background
            @current-change="handleCurrentChangeGroup"
            @size-change="handleSizeChangeGroup"
            :current-page.sync="groupParams.pageNo"
            :page-size.sync="groupParams.pageSize"
            :page-sizes="[15, 30, 50]"
            layout="->, total, sizes, prev, pager, next"
            :total="recordGroupCount"
          ></el-pagination>
        </el-col>
        <el-col :span="12" style="height: 100%">
          <div>
            <el-input
              size="small"
              :placeholder="`${$t('pleaseEnterKeyWords')}`"
              v-model.trim="params.keyword"
              clearable
              class="w-200px"
            />
            <el-button class="ml-10px" type="primary" size="small" @click="searchTableData()">{{
              $t('search')
            }}</el-button>
            <el-button
              type="primary"
              size="small"
              @click="addIdentifier()"
              :disabled="!$hasAccess('create')"
              >{{ $t('create') }}</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="deleteList()"
              :disabled="!$hasAccess('delete')"
              >{{ $t('delete') }}</el-button
            >
            <!-- <el-button size="small" @click="importExperience()">导入</el-button>
            <el-button size="small" @click="exportFile()">导出</el-button> -->
          </div>
          <el-table
            border
            stripe
            :data="tableData"
            v-loading="rightLoading"
            @selection-change="handleSelectionChange"
            :highlight-current-row="true"
            height="calc(100% - 102px)"
            style="width: 100%; overflow-y: auto"
            ref="multipleTable"
            class="mt-20px"
          >
            <el-table-column fixed type="selection" width="55"></el-table-column>
            <el-table-column :label="`${$t('seqNo')}`" prop="seqNo" width="55"></el-table-column>
            <el-table-column :label="`${$t('identifyCode')}`" prop="code"></el-table-column>
            <el-table-column :label="`${$t('identifyName')}`" prop="name"></el-table-column>
            <el-table-column
              :label="`${$t('indentifyClass')}`"
              prop="identifierType"
            ></el-table-column>
            <el-table-column :label="`${$t('operate')}`" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="viewIdentifier(scope.row.id)"
                  :disabled="!$hasAccess('read')"
                  >{{ $t('view') }}</el-button
                >
                <el-button
                  size="mini"
                  @click="editIdentifier(scope.row.id)"
                  :disabled="!$hasAccess('update')"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  size="mini"
                  @click="deleteList(scope.row.id)"
                  :disabled="!$hasAccess('delete')"
                  >{{ $t('delete') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20px"
            background
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="params.pageNo"
            :page-size="params.pageSize"
            :page-sizes="[15, 30, 50]"
            layout="->, total, sizes, prev, pager, next"
            :total="recordCount"
          ></el-pagination>
        </el-col>
      </el-row>
      <!-- 新增、编辑、修改标识组的操作start -->
      <el-dialog
        :title="dialogGroupTitle"
        :visible.sync="dialogGroupVisible"
        :close-on-click-modal="false"
        v-dialogDrag
        class="mini-dialog"
      >
        <el-form
          label-width="150px"
          :model="groupEditeForm"
          :rules="currentLang === 'zh' ? groupEditeRules : groupEditEnRules"
          ref="groupEditeForm"
        >
          <el-form-item :label="`${$t('identifyGroupCode')}`" prop="code">
            <el-input
              clearable
              v-model.trim="groupEditeForm.code"
              :readonly="dialogGroupTitle === $t('viewIdentifyGroup')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('identifyGroupName')}`" prop="name">
            <el-input
              clearable
              v-model.trim="groupEditeForm.name"
              :readonly="dialogGroupTitle === $t('viewIdentifyGroup')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('seqNo')}`" prop="seqNo">
            <el-input-number
              :disabled="dialogGroupTitle === $t('viewIdentifyGroup')"
              v-model.trim="groupEditeForm.seqNo"
              :controls="false"
              class="!w-280px"
            ></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="text-center" v-if="dialogGroupTitle !== $t('viewIdentifyGroup')">
          <el-button @click="closeDialogGroup" size="small" class="iconfont icon-close">
            {{ $t('cancel') }}
          </el-button>
          <el-button @click="submitDialogGroup" :loading="btnLoading" type="primary" size="small">{{
            $t('save')
          }}</el-button>
        </div>
      </el-dialog>
      <!-- 新增、编辑、修改标识的操作start -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        v-dialogDrag
        class="mini-dialog"
      >
        <el-form
          label-width="150px"
          :model="editeForm"
          :rules="currentLang === 'zh' ? editeRules : editEnRules"
          ref="identifierForm"
        >
          <el-form-item :label="`${$t('identifyCode')}`" prop="code">
            <el-input
              v-model.trim="editeForm.code"
              :readonly="dialogTitle === $t('viewIdentify')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('identifyName')}`" prop="name">
            <el-input
              v-model.trim="editeForm.name"
              :readonly="dialogTitle === $t('viewIdentify')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="`${$t('seqNo')}`" prop="seqNo">
            <el-input-number
              v-model.trim="editeForm.seqNo"
              :controls="false"
              class="!w-280px"
              :disabled="dialogTitle === $t('viewIdentify')"
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="`${$t('indentifyType')}`" prop="identifierType">
            <el-select
              filterable
              clearable
              v-model.trim="editeForm.identifierType"
              class="!w-280px"
              data-cy="selectSearch"
              :disabled="dialogTitle === $t('viewIdentify')"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="text-center" v-if="dialogTitle !== $t('viewIdentify')">
          <el-button @click="closeDialog" class="iconfont icon-close" size="small">
            {{ $t('cancel') }}
          </el-button>
          <el-button
            size="small"
            class="iconfont icon-save"
            @click="submitDialog"
            :loading="isLoading"
            type="primary"
            >{{ $t('save') }}</el-button
          >
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
// import uploadExcel from '@/components/upload'
import StdAttributeService from '@/services/StdAttributeService'
import StdIdentifierService from '@/services/StdIdentifierService'
import StdIdentifierGroupService from '@/services/StdIdentifierGroupService'
import ConfirmAuth from '@/assets/js/confirmAuth'

export default {
  name: 'StdAttribute',
  components: {
    // uploadExcel,
  },
  data() {
    return {
      moduleAuth: null,
      dialogTitle: this.$t('createIdentify'),
      dialogGroupTitle: this.$t('createIdentifyGroup'),
      dialogGroupVisible: false,
      dialogVisible: false,
      groupEditeForm: {
        code: '',
        name: '',
        seqNo: '',
      },
      groupEditeRules: {
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'change' },
          {
            required: true,
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: this.$t('pleaseEnterMathesRule'),
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: this.$t('PleaseEnterAName'), trigger: 'blur' }],
      },
      groupEditEnRules: {
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'change' },
          {
            required: true,
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: this.$t('pleaseEnterMathesRule'),
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: this.$t('pleaseEnterTheName'), trigger: 'blur' }],
      },
      editeForm: {
        code: '',
        name: '',
        seqNo: '',
        identifierGroupId: '',
        identifierType: '',
      },
      editeRules: {
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'blur' },
          {
            required: true,
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: this.$t('pleaseEnterMathesRule'),
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: this.$t('PleaseEnterAName'), trigger: 'blur' }],
        identifierType: [
          { required: true, message: this.$t('pleaseSelectIdentifyLevel'), trigger: 'change' },
        ],
      },
      editEnRules: {
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'blur' },
          {
            required: true,
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: this.$t('pleaseEnterMathesRule'),
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: this.$t('pleaseEnterTheName'), trigger: 'blur' }],
        identifierType: [
          { required: true, message: this.$t('pleaseSelectIdentifyLevel'), trigger: 'change' },
        ],
      },
      options: [
        {
          value: 0,
          label: '类别',
        },
        {
          value: 1,
          label: '属性',
        },
        {
          value: 2,
          label: '属性值',
        },
        {
          value: 3,
          label: '标准属性',
        },
      ],
      groupParams: {
        keyword: '',
        pageNo: 1,
        pageSize: 15,
      }, // 标识组查询参数
      recordGroupCount: 0, // 标识组总和
      params: {
        pageNo: 1,
        pageSize: 15,
        keyword: '',
      }, // 标识查询参数
      recordCount: 0, // 标识总和
      groupTableData: [],
      tableLoading: false,
      groupTableLoading: false,
      tableData: [],
      isLoading: false,
      rightLoading: false,
      btnLoading: false,
      selectedId: '',
      multipleSelectionId: [],
    }
  },
  computed: {
    currentLang() {
      return this.$store.getters['System/currentLang']
    },
  },
  async created() {
    // this.moduleAuth = await ConfirmAuth('标识管理')
    this.searchGroupData()
    console.log('created')
  },
  methods: {
    // 查询标签组
    async searchGroupData() {
      this.groupTableLoading = true
      const parameter = this.groupParams
      const res = await StdIdentifierGroupService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.groupTableData = res.data
        if (res.page) {
          this.recordGroupCount = res.page.recordCount
          this.groupParams.pageNo = res.page.pageNo
          this.groupParams.pageSize = res.page.pageSize
        }
        this.groupTableLoading = false
      }
      // 指控选中标识组id以及标识列表
      this.selectedId = ''
      this.tableData = []
    },
    // 新增标识组
    addGroup() {
      this.dialogGroupVisible = true
      this.dialogGroupTitle = this.$t('createIdentifyGroup')
      this.groupEditeForm = {
        code: '',
        name: '',
        seqNo: '',
      }
    },
    // 查看标识组
    async viewIdentifyGroup(id) {
      this.dialogGroupTitle = this.$t('viewIdentifyGroup')
      this.dialogGroupVisible = true
      const res = await StdIdentifierGroupService.detail({ id })
      if (res && res.code === 0 && res.data) {
        this.groupEditeForm = res.data
      }
    },
    // 编辑标识组
    async editGroup(id) {
      this.dialogGroupTitle = this.$t('editIdentifyGroup')
      this.dialogGroupVisible = true
      const res = await StdIdentifierGroupService.detail({ id })
      if (res && res.code === 0 && res.data) {
        this.groupEditeForm = res.data
      }
    },
    // 删除标识组
    deleteGroup(id) {
      this.$confirm(this.$t('confirmDeleteReidentityGroup'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await StdIdentifierGroupService.remove({ data: [id] })
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: res.msg,
            })
            if (this.groupTableData.length === 1 && this.groupParams.pageNo > 1) {
              this.groupParams.pageNo -= 1
            }
            this.searchGroupData()
          }
        })
        .catch(() => {})
    },
    // 标识组取消操作
    closeDialogGroup() {
      this.dialogGroupVisible = false
    },
    // 标识组确定操作
    submitDialogGroup() {
      this.$refs.groupEditeForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          if (this.dialogGroupTitle === this.$t('createIdentifyGroup')) {
            this.saveGroup()
          } else {
            this.updateGroup()
          }
        }
      })
    },
    async saveGroup() {
      const parameter = {
        model: this.groupEditeForm,
      }
      const res = await StdIdentifierGroupService.create(parameter)
      if (res && res.code === 0) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.dialogGroupVisible = false
        this.searchGroupData()
      }
      this.btnLoading = false
    },
    async updateGroup() {
      const parameter = {
        model: this.groupEditeForm,
      }
      const res = await StdIdentifierGroupService.update(parameter)
      if (res && res.code === 0) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.dialogGroupVisible = false
        this.searchGroupData()
      }
      this.btnLoading = false
    },

    // 选中标识组
    clickGroupTableRow(obj) {
      this.selectedId = obj.id
      this.initIdentiferData()
    },
    // 查询标识列表
    async initIdentiferData() {
      this.rightLoading = true
      const parameter = this.params
      parameter.identifier_Group_Id = this.selectedId
      const res = await StdIdentifierService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.tableData.forEach((item) => {
          if (item.identifierType !== '') {
            item.identifierType = this.filterIdentifierType(item.identifierType)
          }
        })
        if (res.page) {
          this.recordCount = res.page.recordCount
          this.params.pageNo = res.page.pageNo
          this.params.pageSize = res.page.pageSize
        }
        this.rightLoading = false
      }
    },
    filterIdentifierType(val) {
      const arr = ['类别', '属性', '属性值', '标准属性']
      return arr[val]
    },
    // 搜索标识
    async searchTableData() {
      if (!this.selectedId) {
        this.$message({
          message: this.$t('pleaseSelectIdentifyGroup'),
          type: 'warning',
        })
        return
      }
      this.initIdentiferData()
    },
    // 新增标识
    addIdentifier() {
      if (!this.selectedId) {
        this.$message({
          message: this.$t('pleaseSelectIdentifyGroup'),
          type: 'warning',
        })
        return
      }
      this.dialogVisible = true
      this.dialogTitle = this.$t('createIdentify')
      this.editeForm = {
        code: '',
        name: '',
        seqNo: '',
        identifierGroupId: this.selectedId,
        identifierType: '',
      }
    },
    async viewIdentifier(id) {
      this.dialogVisible = true
      this.dialogTitle = this.$t('viewIdentify')
      const res = await StdIdentifierService.detail({ id })
      if (res && res.code === 0 && res.data) {
        this.editeForm = res.data
      }
    },
    async editIdentifier(id) {
      this.dialogVisible = true
      this.dialogTitle = this.$t('editIdentify')
      const res = await StdIdentifierService.detail({ id })
      if (res && res.code === 0 && res.data) {
        this.editeForm = res.data
      }
    },
    // 确认提交标识
    submitDialog() {
      this.$refs.identifierForm.validate((valid) => {
        if (valid) {
          this.isLoading = true
          if (this.dialogTitle === this.$t('createIdentify')) {
            this.save()
          } else {
            this.update()
          }
        }
      })
    },
    async save() {
      const parameter = {
        model: this.editeForm,
      }
      parameter.identifier_Group_Id = this.selectedId
      const res = await StdIdentifierService.create(parameter)
      if (res && res.code === 0) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.dialogVisible = false
        this.searchTableData()
      }
      this.isLoading = false
    },
    async update() {
      const parameter = {
        model: this.editeForm,
      }
      parameter.identifier_Group_Id = this.selectedId
      const res = await StdIdentifierService.update(parameter)
      if (res && res.code === 0) {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.dialogVisible = false
        this.searchTableData()
      }
      this.isLoading = false
    },
    // 标识取消操作
    closeDialog() {
      this.dialogVisible = false
    },
    handleSelectionChange(val) {
      this.multipleSelectionId = val.map((item) => {
        return item.id
      })
    },
    // 批量删除操作
    deleteList(id) {
      const parameter = {}
      if (id) {
        parameter.data = [id]
      } else {
        if (!this.multipleSelectionId.length) {
          this.$message({
            message: this.$t('pleaseSelectDeleteIdentify'),
            type: 'warning',
          })
          return
        }
        parameter.data = this.multipleSelectionId
      }
      this.$confirm(this.$t('confirmDeleteTheIdentify'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await StdIdentifierService.remove(parameter)
          if (res && res.code === 0) {
            this.$message({
              type: 'success',
              message: res.msg,
            })
            if (this.tableData.length === 1 && this.params.pageNo > 1) {
              this.params.pageNo -= 1
            }
            this.searchTableData()
          }
        })
        .catch(() => {})
    },
    importExperience() {},
    async exportFile() {
      const res = await StdAttributeService.exportFile({
        downloadFileName: '',
        urlParam: '',
        ids: [],
        downloadType: 0,
      })
      if (res && res.url && res.code === 0) {
        if (_.includes(res.url, '://')) {
          window.location.href = res.url
        } else {
          window.location.href = `${currentEnv.VUE_APP_STANDARD_SERVER}${res.url}`
        }
      }
    },
    handleCurrentChangeGroup(num) {
      this.groupParams.pageNo = num
      this.searchGroupData()
    },
    handleSizeChangeGroup(size) {
      this.groupParams.pageSize = size
      this.searchGroupData()
    },
    handleCurrentChange(num) {
      this.params.pageNo = num
      this.initIdentiferData()
    },
    handleSizeChange(size) {
      this.params.pageSize = size
      this.initIdentiferData()
    },
  },
}
</script>
<style lang="scss" scoped>

#StdAttribute {
  /deep/.el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
}

</style>
